(function () {

	const handleStickyHeader = () => {
		const headerElem = document.querySelector(".header");

		if (!headerElem) return;

		const observer = new IntersectionObserver(
			([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
			{ threshold: [1] }
		);

		observer.observe(headerElem);
	};

	const handleContactForm = () => {
		const contactForm = document.querySelector("#ContactForm");

		if (!contactForm) return;

		const selectElement = document.getElementById('ContactForm-request-type');

		selectElement.addEventListener('change', function () {
			console.log(selectElement);
			const selectedOption = this.options[this.selectedIndex];
			const ariaControlsValue = selectedOption.getAttribute('aria-controls');
			const textareas = document.querySelectorAll('.form--select');

			textareas.forEach(function (textarea) {
				const textareaId = textarea.id;
				if (textareaId === ariaControlsValue) {
					document.getElementById(textareaId).classList.remove('hide');
				} else {
					document.getElementById(textareaId).classList.add('hide');
				}
			});
		});
	};

	const handleNewsletterForm = () => {
		const form = document.querySelector('.newsletter-form');

		if (!form) return;

		const errorMessage = document.querySelector('.newsletter-form .newsletter-form__message--error');
		const successMessage = document.querySelector('.newsletter-form .newsletter-form__message--success');

		form.addEventListener('submit', function (e) {
			e.preventDefault();

			const formData = new FormData(form);
			const email = formData.get('email');

			const payload = {
				data: {
					type: 'subscription',
					attributes: {
						custom_source: 'Footer Sign Up',
						profile: {
							data: {
								type: 'profile',
								attributes: {
									email: email,
								},
							},
						},
					},
					relationships: {
						list: {
							data: {
								type: 'list',
								id: 'SDxik3',
							},
						},
					},
				},
			};

			const requestOptions = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					revision: '2023-12-15',
				},
				body: JSON.stringify(payload),
			};

			fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SY4jHB', requestOptions)
				.then((response) => {
					if (!response.ok) {
						throw new Error('Network response was not ok');
					}
					if (response.status === 202) {
						return { message: 'Accepted, no content' };
					}
					return response.json();
				})
				.then((data) => {
					successMessage.classList.remove('hide');
					form.reset();
				})
				.catch((error) => {
					errorMessage.classList.remove('hide');
				})
				.finally(() => {
				});
		});
	};

	// const handleSignupForm = () => {
	// 	const form = document.querySelector('.signup__form');

	// 	if (!form) return;

	// 	const errorMessage = document.querySelector('.signup__form .field__message--error');
	// 	const successMessage = document.querySelector('.signup__form .field__message--success');

	// 	form.addEventListener('submit', function (e) {
	// 		e.preventDefault();

	// 		const formData = new FormData(form);
	// 		const email = formData.get('email');

	// 		const payload = {
	// 			data: {
	// 				type: 'subscription',
	// 				attributes: {
	// 					custom_source: 'First Order Sign Up',
	// 					profile: {
	// 						data: {
	// 							type: 'profile',
	// 							attributes: {
	// 								email: email,
	// 							},
	// 						},
	// 					},
	// 				},
	// 				relationships: {
	// 					list: {
	// 						data: {
	// 							type: 'list',
	// 							id: 'SDxik3',
	// 						},
	// 					},
	// 				},
	// 			},
	// 		};

	// 		const requestOptions = {
	// 			method: 'POST',
	// 			headers: {
	// 				'Content-Type': 'application/json',
	// 				revision: '2023-12-15',
	// 			},
	// 			body: JSON.stringify(payload),
	// 		};

	// 		fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SY4jHB', requestOptions)
	// 			.then((response) => {
	// 				if (!response.ok) {
	// 					throw new Error('Network response was not ok');
	// 				}
	// 				if (response.status === 202) {
	// 					return { message: 'Accepted, no content' };
	// 				}
	// 				return response.json();
	// 			})
	// 			.then((data) => {
	// 				successMessage.classList.remove('hide');
	// 				form.reset();
	// 			})
	// 			.catch((error) => {
	// 				errorMessage.classList.remove('hide');
	// 			})
	// 			.finally(() => {
	// 			});
	// 	});
	// };

	const handleBisForm = () => {
		const forms = document.querySelectorAll('.bis__form');

		if (!forms.length) return;

		forms.forEach((form) => {
			const errorMessage = form.querySelector('.field__message--error');
			const successMessage = form.querySelector('.field__message--success');
			const submitBtn = form.querySelector('button.btn');
			const spinner = submitBtn?.querySelector('.loading__spinner');

			// The button is type="button" so we listen on click, not submit.
			submitBtn?.addEventListener('click', function (e) {
				e.preventDefault();

				// Native HTML5 validation (required, type=email)
				if (!form.checkValidity()) {
					form.reportValidity();
					return;
				}

				// Reset any previous state
				errorMessage?.classList.add('hide');
				successMessage?.classList.add('hide');
				spinner?.classList.remove('hide');
				submitBtn.disabled = true;

				const formData = new FormData(form);
				const email = formData.get('email');
				const variantId = formData.get('variant');
				const companyId = formData.get('a') || 'SY4jHB';

				const payload = {
					data: {
						type: 'back-in-stock-subscription',
						attributes: {
							profile: {
								data: {
									type: 'profile',
									attributes: { email: email },
								},
							},
							channels: ['EMAIL'],
						},
						relationships: {
							variant: {
								data: {
									type: 'catalog-variant',
									id: `$shopify:::$default:::${variantId}`,
								},
							},
						},
					},
				};

				fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						revision: '2023-12-15',
					},
					body: JSON.stringify(payload),
				})
					.then((response) => {
						if (!response.ok) throw new Error('Network response was not ok');
						if (response.status === 202) return { message: 'Accepted, no content' };
						return response.json();
					})
					.then(() => {
						successMessage?.classList.remove('hide');
						form.reset();
					})
					.catch(() => {
						errorMessage?.classList.remove('hide');
					})
					.finally(() => {
						spinner?.classList.add('hide');
						submitBtn.disabled = false;
					});
			});
		});
	};

	/* ------------------------------------------------------------------ */
	/* Hero                                                               */
	/* ------------------------------------------------------------------ */
	const HERO_SLIDE_DURATION = 3600;
	const HERO_STAGGER_DELAY = 125;
	const heroSliders = new WeakMap();

	/* Legacy mode (Brewery hero / no slider): identical to old behaviour */
	const runLegacyHero = (cols) => {
		function animateParallel(columns) {
			columns.forEach((col, idx) => {
				const imgs = Array.from(col.querySelectorAll('img'));
				let current = 0;
				imgs.forEach((img, i) => img.classList.toggle('active', i === 0));
				setTimeout(function fade() {
					const next = (current + 1) % imgs.length;
					imgs[current].classList.remove('active');
					imgs[next].classList.add('active');
					current = next;
					setTimeout(fade, HERO_SLIDE_DURATION);
				}, HERO_SLIDE_DURATION + idx * HERO_STAGGER_DELAY);
			});
		}

		function animateSingle(col) {
			const imgs = Array.from(col.querySelectorAll('img'));
			let current = 0;
			imgs.forEach((img, i) => img.classList.toggle('active', i === 0));
			setInterval(() => {
				const next = (current + 1) % imgs.length;
				imgs[current].classList.remove('active');
				imgs[next].classList.add('active');
				current = next;
			}, HERO_SLIDE_DURATION);
		}

		if (window.innerWidth < 768 && cols.length > 1) {
			const first = cols[0];
			cols[1].querySelectorAll('img').forEach(img => first.appendChild(img));
			cols[1].style.display = 'none';
			animateSingle(first);
		} else {
			animateParallel(cols);
		}
	};

	/* ------------------------------------------------------------------ */
	/* Slider mode (Home Hero section): each image pair + its copy is one */
	/* slide. Timing comes from the section settings (data attributes).   */
	/* Returns a controller so the theme editor can pause, jump to a      */
	/* slide and tear it down when the section re-renders.                */
	/* ------------------------------------------------------------------ */
	const createHeroSlider = (hero) => {
		const cols = Array.from(hero.querySelectorAll('.hero__media'));
		const contents = Array.from(hero.querySelectorAll('.hero__content[data-slide]'));
		const dots = Array.from(hero.querySelectorAll('[data-slide-dot]'));
		const slideCount = parseInt(hero.dataset.slideCount, 10) || contents.length;
		const speed = parseFloat(hero.dataset.autoplaySpeed);
		const slideDuration = speed > 0 ? Math.round(speed * 1000) : HERO_SLIDE_DURATION;
		const autoplay = hero.dataset.autoplay !== 'false';
		const isMobile = window.innerWidth < 768 && cols.length > 1;

		if (slideCount < 1) return null;

		/* A frame is one step of the slideshow. Desktop: one per slide, both */
		/* columns crossfading together (right column 125ms behind). Mobile:  */
		/* both columns merge into one and every image is its own frame      */
		/* (left, right, left, right...), switching the copy/dots when the    */
		/* pair changes. A slide with no images still gets a frame.           */
		const frames = [];

		if (isMobile) {
			const [first, ...others] = cols;

			for (let s = 0; s < slideCount; s++) {
				const media = cols
					.map((col) => col.querySelector('[data-slide="' + s + '"]'))
					.filter(Boolean);

				media.forEach((item) => {
					if (item.parentElement !== first) first.appendChild(item);
					frames.push({ slide: s, media: item });
				});

				if (!media.length) frames.push({ slide: s, media: null });
			}

			others.forEach((col) => {
				col.style.display = 'none';
			});
		} else {
			for (let s = 0; s < slideCount; s++) frames.push({ slide: s });
		}

		let currentFrame = 0;
		let timer = null;
		let staggerTimers = [];
		let paused = false;

		const clearStagger = () => {
			staggerTimers.forEach(clearTimeout);
			staggerTimers = [];
		};

		const setActiveContent = (slide) => {
			contents.forEach((content) => {
				content.classList.toggle('active', Number(content.dataset.slide) === slide);
			});
			dots.forEach((dot) => {
				const isActive = Number(dot.dataset.slideDot) === slide;
				dot.classList.toggle('active', isActive);
				dot.setAttribute('aria-current', isActive ? 'true' : 'false');
			});
		};

		const setColumnSlide = (col, slide) => {
			col.querySelectorAll('[data-slide]').forEach((item) => {
				item.classList.toggle('active', Number(item.dataset.slide) === slide);
			});
		};

		const goToFrame = (index) => {
			currentFrame = ((index % frames.length) + frames.length) % frames.length;
			const frame = frames[currentFrame];

			if (isMobile) {
				cols[0].querySelectorAll('[data-slide]').forEach((item) => {
					item.classList.toggle('active', item === frame.media);
				});
			} else {
				clearStagger();
				cols.forEach((col, idx) => {
					const delay = idx * HERO_STAGGER_DELAY;
					if (delay) {
						staggerTimers.push(setTimeout(() => setColumnSlide(col, frame.slide), delay));
					} else {
						setColumnSlide(col, frame.slide);
					}
				});
			}

			setActiveContent(frame.slide);
		};

		const goToSlide = (slide) => {
			const index = frames.findIndex((frame) => frame.slide === slide);
			if (index !== -1) goToFrame(index);
		};

		const stop = () => {
			if (timer) clearInterval(timer);
			timer = null;
		};

		const play = () => {
			stop();
			if (autoplay && !paused && frames.length > 1) {
				timer = setInterval(() => goToFrame(currentFrame + 1), slideDuration);
			}
		};

		dots.forEach((dot) => {
			dot.addEventListener('click', () => {
				goToSlide(Number(dot.dataset.slideDot));
				play();
			});
		});

		goToFrame(0);
		play();

		return {
			goToSlide,
			pause() {
				paused = true;
				stop();
			},
			resume() {
				paused = false;
				play();
			},
			destroy() {
				stop();
				clearStagger();
			},
		};
	};

	const initHeroSlider = (hero) => {
		if (heroSliders.has(hero)) return;
		const slider = createHeroSlider(hero);
		if (slider) heroSliders.set(hero, slider);
	};

	const handleHeroAnimation = () => {
		const sliders = document.querySelectorAll('[data-hero-slider]');

		if (sliders.length) {
			sliders.forEach(initHeroSlider);
			return;
		}

		const cols = Array.from(document.querySelectorAll('.hero__media'));
		if (cols.length) runLegacyHero(cols);
	};

	/* Theme editor: start sliders in re-rendered sections, stop removed  */
	/* ones, and hold on a slide while its block is selected.             */
	const handleHeroEditorEvents = () => {
		const sliderFor = (el) => {
			const hero = el instanceof Element ? el.closest('[data-hero-slider]') : null;
			return hero ? heroSliders.get(hero) : null;
		};

		document.addEventListener('shopify:section:load', (event) => {
			event.target.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
		});

		document.addEventListener('shopify:section:unload', (event) => {
			event.target.querySelectorAll('[data-hero-slider]').forEach((hero) => {
				heroSliders.get(hero)?.destroy();
				heroSliders.delete(hero);
			});
		});

		document.addEventListener('shopify:block:select', (event) => {
			const slider = sliderFor(event.target);
			if (!slider) return;
			slider.pause();
			slider.goToSlide(Number(event.target.dataset.slide));
		});

		document.addEventListener('shopify:block:deselect', (event) => {
			sliderFor(event.target)?.resume();
		});
	};

	const handleSearchForm = () => {
		const containers = document.querySelectorAll('details-modal.header__search');
		if (!containers.length) return;

		containers.forEach(function (container) {
			const details = container.querySelector('details');
			const input = container.querySelector('input[type="search"]');
			if (!details || !input) return;

			// When the <details> is opened via the header icon, focus the input.
			details.addEventListener('toggle', function () {
				if (details.open) {
					// Wait a tick so any open animation runs before focusing.
					requestAnimationFrame(function () {
						try {
							input.focus({ preventScroll: true });
						} catch (e) {
							input.focus();
						}
						input.dispatchEvent(new Event('input', { bubbles: true }));
					});
				}
			});
		});
	};

	document.addEventListener('DOMContentLoaded', function () {
		handleStickyHeader();
		handleContactForm();
		handleNewsletterForm();
		// handleSignupForm();
		handleHeroAnimation();
		handleHeroEditorEvents();
		handleSearchForm();
		handleBisForm();
	});

}());
